import { render, staticRenderFns } from "./Submenu4.vue?vue&type=template&id=34a8fb28&scoped=true&"
import script from "./Submenu4.vue?vue&type=script&lang=js&"
export * from "./Submenu4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a8fb28",
  null
  
)

export default component.exports